<template>
    <div>
        <b-container>
            <b-row>
                <b-col>
                    <app-support-list-filters
                        @filter="onFilter"
                    ></app-support-list-filters>
                </b-col>
            </b-row>
            <b-row>
            <b-col>
                <app-support-list
                    :table-data="tableData"
                    :on-change-page="onChangePage"
                    @edit="onEdit"
                    @sort ="onSort"
                ></app-support-list>
            </b-col>
        </b-row>
        <app-pop-up
            id="ticket-attention-form-window"
            title="Informacion general del ticket"
            size="large"
        >
            <template slot="body">
                <app-support-form
                ref="supportForm"
                @ticket-saved-note="onTicketSavedNote"
                @ticket-saved="onTicketSaved"
                @attended="onTicketAttended"
                @closed="onClosed"
                @requested="onTicketRequested"
                @inReview="onTicketInReview"
                ></app-support-form>
            </template>
            <template slot="buttons">
                <div v-show="requestedInfo">
                <b-btn  @click="solicitInformation">Solicitar mas informacion</b-btn>
                </div>
                <div v-show="attended">
                <b-btn  @click="attendRequest">Atender</b-btn>
                </div>
                <div v-show="finalize">
                <b-btn  @click="finalizeRequest">Finalizar</b-btn>
                </div>
                <div v-show="closeTicket">
                <b-btn  @click="closeRequest">Cerrar Ticket</b-btn>
                </div>
            </template>
        </app-pop-up>
        </b-container>
    </div>
</template>
<script>
import SupportListFilters from './SupportListFilters';
import SupportForm from './SupportForm';
import SupportList from './SupportList';
export default {
    data: () => ({
        page: 1,
        filters: null,
        tableData: '',
        sortBy: 'tickets.created_at',
        sortDir: 'desc',
        attended: true,
        requestedInfo: true,
        finalize: true,
        closeReq: true,
        closeTicket: true,
        flagPageSupport: true,
        ticket: [],
        clone: '',
        backdrop: '',
        askForReject: false
    }),
    components: {
        appSupportForm: SupportForm,
        appSupportListFilters: SupportListFilters,
        appSupportList: SupportList
    },
    methods: {
        onTicketRequested() {
            this.finalize = false;
            this.attended = true;
            this.requestedInfo = true;
            this.closeTicket = true;
        },
        onTicketAttended() {
            this.attended = false;
            this.requestedInfo = false;
            this.finalize = true;
            this.closeReq = true;
        },
        onClosed() {
            this.attended = false;
            this.requestedInfo = false;
            this.finalize = false;
            this.closeReq = false;
            this.askForReject = false;
        },
        onTicketInReview() {
            this.attended = true;
            this.requestedInfo = true;
            this.finalize = false;
            this.closeReq = true;
        },
        solicitInformation(){
            this.$refs.supportForm.moreInformation();
        },
        attendRequest(){
            this.$refs.supportForm.attendRequestEnable();
        },
        finalizeRequest(){ 
            this.$refs.supportForm.finalizeTicketEnable();
        },
        closeRequest(){
            this.$refs.supportForm.closeRequestEnable();
        },
        onFilter(filters) {
            this.filters = filters;
            this.page = 1;
            this.loadTickets();
        },
        async loadTickets() {
            try {
                const params = {...this.filters, page: this.page, sortBy: this.sortBy, 
                sortDir: this.sortDir,flagPageSupport: this.flagPageSupport};
                const {data} = await repo.get('tickets',params);
                this.tableData = data;
            } catch(err) {
                this.handleErrors(err);
            }
        },
        onChangePage(page) {
            this.page = page;
            this.loadTickets();
        },
        onSort(ctx) {
            this.sortBy = ctx.sortBy;
            this.sortDir = ctx.sortDir;
            this.loadTickets();
        },
        onEdit(ticket) {
            this.ticket = ticket;
            this.$refs.supportForm.fill(ticket);
            this.$bus.$emit('ticket-attention-form-window.open');
        },
        onTicketSaved(ticket) {
            this.$bus.$emit('ticket-attention-form-window.close');
            this.loadTickets();
        },
        onTicketSavedNote(){
            this.loadTickets(); 
        },
    },
    mounted() {
        this.loadTickets();
    }

}
</script>
<style lang="css" scoped>
    .button-box {
        border: 1px solid darkgray;
        border-radius: 6px;
        padding: 14px;
        padding-bottom: 0;
    }
</style>